import React from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FormatAddressString } from "go-core/components/Formatters/FormatAddress";
import { ReactComponent as HomeSVG } from "go-core/images/svg/home.svg";
import { ReactComponent as InfoSVG } from "go-core/images/svg/info.svg";
import { ReactComponent as TaxSVG } from "go-core/images/svg/tax.svg";
import { PartnerApi } from "../../../../../../../../../services/Api/Partner/partnerTypes";

interface Props {
	partner: PartnerApi;
}

const PartnerCompanyCard = ({ partner }: Props) => {
	const { t } = useTranslation("admin");
	const address = {
		street: partner.company_street,
		build_nr: partner.company_build_nr,
		flat_nr: partner.company_flat_nr,
		zip_code: partner.company_zip_code,
		city: partner.company_city,
	};

	return (
		<Card>
			<Card.Body>
				<h5>{t("common.word.company_info")}</h5>
				{partner.company_name && (
					<div className={"card-body-item"}>
						<InfoSVG />
						<div className={"item-info"}>
							<span>{partner.company_name}</span>
						</div>
					</div>
				)}
				{(partner.company_zip_code ||
					partner.company_flat_nr ||
					partner.company_city ||
					partner.company_street ||
					partner.company_build_nr) && (
					<div className={"card-body-item"}>
						<HomeSVG />
						<div className={"item-info"}>
							<span>{FormatAddressString(address)}</span>
						</div>
					</div>
				)}
				{partner.company_tax_id_no && (
					<div className="card-body-item">
						<TaxSVG />
						<div className="item-info">
							<span>{partner.company_tax_id_no}</span>
						</div>
					</div>
				)}
			</Card.Body>
		</Card>
	);
};
export default PartnerCompanyCard;
